import { render, staticRenderFns } from "./LinesTable.vue?vue&type=template&id=cafa2ad2&scoped=true&"
import script from "./LinesTable.vue?vue&type=script&lang=js&"
export * from "./LinesTable.vue?vue&type=script&lang=js&"
import style0 from "./LinesTable.vue?vue&type=style&index=0&id=cafa2ad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafa2ad2",
  null
  
)

export default component.exports